import { render, staticRenderFns } from "./X-avancement-reception.vue?vue&type=template&id=fbbd598a&scoped=true"
import script from "./X-avancement-reception.vue?vue&type=script&lang=js"
export * from "./X-avancement-reception.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbd598a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbbd598a')) {
      api.createRecord('fbbd598a', component.options)
    } else {
      api.reload('fbbd598a', component.options)
    }
    module.hot.accept("./X-avancement-reception.vue?vue&type=template&id=fbbd598a&scoped=true", function () {
      api.rerender('fbbd598a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chantier/avancement/X-avancement-reception.vue"
export default component.exports